import { MappingService } from '@app/api/mapping';
import { AvailableForecasts } from '@app/api/mapping/types';

let cachedAvailableForecasts: AvailableForecasts | null = null;
let inflightPromise: Promise<AvailableForecasts> | null = null;
let lastError: unknown = null;

const listeners = new Set<(data: AvailableForecasts | null) => void>();

function notifyListeners() {
  for (const listener of listeners) {
    try {
      listener(cachedAvailableForecasts);
    } catch {
      // no-op for listener errors
    }
  }
}

export function getCachedAvailableForecasts(): AvailableForecasts | null {
  return cachedAvailableForecasts;
}

export function getAvailableForecastsError(): unknown {
  return lastError;
}

export function isFetchingAvailableForecasts(): boolean {
  return inflightPromise != null;
}

export function subscribeToAvailableForecasts(
  listener: (data: AvailableForecasts | null) => void,
): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export async function fetchAndUpdateAvailableForecasts(
  demo?: boolean,
): Promise<AvailableForecasts> {
  if (inflightPromise != null) {
    return inflightPromise;
  }

  inflightPromise = MappingService.getAvailableForecasts(demo)
    .then((data) => {
      cachedAvailableForecasts = data;
      lastError = null;
      notifyListeners();
      return data;
    })
    .catch((err) => {
      lastError = err;
      throw err;
    })
    .finally(() => {
      inflightPromise = null;
    });

  return inflightPromise;
}
